import type { EventDetail } from "@cdt/shared";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { formatDateTimeLong } from "@/lib/formatters";

interface EventEmailBodyProps {
  event: EventDetail;
}

export function EventEmailBody({ event }: EventEmailBodyProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Email originale</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <dl className="grid grid-cols-1 gap-x-6 gap-y-2 md:grid-cols-[max-content,1fr] text-sm">
          <dt className="font-medium text-muted-foreground">Oggetto</dt>
          <dd>{event.emailSubject}</dd>

          <dt className="font-medium text-muted-foreground">Da</dt>
          <dd>{event.emailFrom}</dd>

          <dt className="font-medium text-muted-foreground">Ricevuta</dt>
          <dd>{formatDateTimeLong(event.emailReceivedAt)}</dd>
        </dl>

        <div>
          <div className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Corpo
          </div>
          {event.emailBody === null || event.emailBody.trim().length === 0 ? (
            <p className="rounded-md border border-dashed bg-muted/30 p-4 text-sm text-muted-foreground">
              Corpo non disponibile (record precedente all'introduzione del
              campo o email senza testo).
            </p>
          ) : (
            <pre className="max-h-[480px] overflow-auto rounded-md border bg-muted/30 p-4 font-mono text-xs whitespace-pre-wrap break-words">
              {event.emailBody}
            </pre>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
